import type { Movement } from "@services/movement-services/types";
import { getCurrentMovementService } from "@services/movementServicesApi";
import { useQuery } from "@tanstack/react-query";

interface UseCurrentMovementsParams {
  service?: string;
  vesselCallId?: string;
  vesselId?: string;
  enabled?: boolean;
  staleTime?: number;
  refetchInterval?: number;
  refetchOnMount?: boolean;
  refetchOnWindowFocus?: boolean;
}

export const useCurrentMovements = ({
  service = "bff-vessel-call",
  vesselCallId,
  vesselId,
  enabled = true,
  staleTime,
  refetchInterval,
  refetchOnMount,
  refetchOnWindowFocus,
}: UseCurrentMovementsParams) =>
  useQuery<Movement[]>({
    queryKey: ["getCurrentMovementService", vesselCallId, vesselId, service],
    queryFn: () =>
      getCurrentMovementService({
        service,
        vesselCallId: vesselCallId as string,
        vesselId: vesselId as string,
      }),
    enabled: !!vesselCallId && !!vesselId && enabled,
    ...(staleTime !== undefined && { staleTime }),
    ...(refetchInterval !== undefined && { refetchInterval }),
    ...(refetchOnMount !== undefined && { refetchOnMount }),
    ...(refetchOnWindowFocus !== undefined && { refetchOnWindowFocus }),
  });
